import React from 'react';
import { useIntl } from 'react-intl';
import { string, object } from 'yup';
import { Formik, Field } from 'formik';
import formMessages from '@whitelabel/helpers/forms/messages';
import commomMessages from '@whitelabel/helpers/messages/commonMsg';
import { INVALID_QUOTES } from '@whitelabel/helpers/constants';
import { StyledButton } from '../style';
import messages from './messages';
import { StyledFormikFormField, StyledForm, StyledLabel, StyledAlert } from './styledPostcode';

type Props = {
  getNewQuote: (...args: any[]) => any;
  setUserEnteredPostcode: (...args: any[]) => any;
};

export const Postcode = ({ getNewQuote, setUserEnteredPostcode }: Props) => {
  const intl = useIntl();

  const initialValues = {
    postcode: '',
  };

  const validationSchema = object({
    postcode: string()
      .trim()
      .required(intl.formatMessage(messages.postcodeError))
      .min(5, intl.formatMessage(messages.postcodeError)),
  });

  const onSubmit = async (values: any, { setSubmitting, setFieldError, setStatus }: any) => {
    try {
      await getNewQuote({ ...values, country: 'US' });
      setUserEnteredPostcode(values.postcode);
    } catch (error) {
      if (error === INVALID_QUOTES) {
        setFieldError('postcode', intl.formatMessage(messages.locationError));
        setStatus(intl.formatMessage(formMessages.locationError));
      } else {
        setStatus(intl.formatMessage(commomMessages.error));
      }
      setSubmitting(false);
    }
  };

  const handleOnChange =
    (setFieldValue: any, status: any, setStatus: any) =>
    ({ target: { name, value } }: any) => {
      if (status) setStatus();
      if (value.match(/^\d+$/) || !value) {
        setFieldValue(name, value);
      }
    };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ isSubmitting, setFieldValue, status, setStatus }) => (
        <StyledForm>
          <StyledLabel for="postcode">{intl.formatMessage(messages.postcodeLabel)}</StyledLabel>
          {status && <StyledAlert color="danger">{status}</StyledAlert>}
          <Field
            id="postcode"
            type="text"
            name="postcode"
            component={StyledFormikFormField}
            onChange={handleOnChange(setFieldValue, status, setStatus)}
            maxLength="5"
            placeholder={intl.formatMessage(messages.postcodePlaceholder)}
          />
          <StyledButton id="postcode-submit" type="submit" loading={isSubmitting}>
            {intl.formatMessage(messages.buttonText)}
          </StyledButton>
        </StyledForm>
      )}
    </Formik>
  );
};

export default Postcode;
